import OInputField from 'components/reusable/OInputField';
import useToastContext from 'hooks/useToastContext';
import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { apiGet } from 'utils/apiFetch';
import apiPath from 'utils/apiPath';

const InitialValidation = ({
    setPropertyIdAndTabFn,
    setEditProperty,
    editProperty,
    propertyId,
    setTab,
}) => {
    const { t } = useTranslation();
    const notification = useToastContext();

    const {
        register,
        setValue,
        handleSubmit,
        formState: { errors },
    } = useForm({ mode: 'onBlur', shouldFocusError: true, defaultValues: {} });

    const submit = async (data) => {
        try {
            const { ad_license_number, advertiser_id } = data;

            const res = await apiGet(apiPath.advertisementValidator, {
                adLicenseNumber: ad_license_number,
                advertiserId: advertiser_id,
                idType: process.env.REACT_APP_ID_TYPE,
            });

            if (res?.data?.success) {
                const validatorRes = res?.data?.results?.result;

                if (validatorRes.isValid === true) {
                    const { longitude, latitude } =
                        validatorRes.advertisement.location;
                    let obj = {
                        advertisementValidatorResponse: validatorRes,
                        cityId:
                            validatorRes?.advertisement?.location?.cityId ??
                            null,
                        communityId:
                            validatorRes?.advertisement?.location
                                ?.communityId ?? null,
                        subCommunityId:
                            validatorRes?.advertisement?.location
                                ?.subCommunityId ?? null,
                        bua: validatorRes?.advertisement?.propertyArea ?? null,
                        price:
                            validatorRes?.advertisement?.propertyPrice ?? null,
                        bedrooms:
                            validatorRes?.advertisement?.numberOfRooms ?? null,
                    };

                    if (validatorRes?.advertisement?.propertyPrice && validatorRes?.advertisement?.propertyArea) { 
                        const tempPricePerUnit =
                        Number.parseFloat(
                            (
                                Number.parseFloat(validatorRes?.advertisement?.propertyPrice) /
                                Number.parseFloat(
                                    validatorRes?.advertisement?.propertyArea
                                )
                            ).toFixed(2)
                        );
                    if (
                        tempPricePerUnit > 0 &&
                        tempPricePerUnit !== 'Infinity'
                    ) {
                        obj.pricePerUnit = tempPricePerUnit;
                    }
                    }


                    if (longitude && latitude) {
                        obj.location = {
                            coordinates: [
                                parseFloat(longitude),
                                parseFloat(latitude),
                            ],
                            type: 'Point',
                        };
                    }

                    setEditProperty(obj);
                    setTab('basic_info');
                } else {
                    notification.error(
                        validatorRes?.message || t('SOMETHING_WENT_WRONG')
                    );
                }
            }
        } catch (error) {
            console.log(error);
            notification.error(error.message || t('SOMETHING_WENT_WRONG'));
        }
    };


    useEffect(() => {
        if (!isEmpty(editProperty)) {
            setValue(
              "advertiser_id",
              editProperty?.advertisementValidatorResponse?.advertisement
                ?.advertiserId
            );
            setValue(
              "ad_license_number",
              editProperty?.advertisementValidatorResponse?.advertisement
                ?.adLicenseNumber
            );
          }
            // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editProperty, propertyId])

    return (
        <>
            <div>
                <form onSubmit={handleSubmit(submit)}>
                    <div className="grid grid-rows-1 grid-cols-2 gap-4">
                        <div className="mb-3">
                            <label className="block">
                                <OInputField
                                    wrapperClassName="relative z-0 w-full group"
                                    name="ad_license_number"
                                    inputLabel={
                                        <>
                                            {t('AD_LICENSE_NUMBER')}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </>
                                    }
                                    type="text"
                                    disabled={propertyId ? true : false}
                                    register={register('ad_license_number', {
                                        required: {
                                            value: true,
                                            message:
                                                'Please enter ad license number.',
                                        },
                                        minLength: {
                                            value: 2,
                                            message:
                                                'Minimum length must be 2.',
                                        },
                                        validate: (value) =>
                                            value.trim()
                                                ? true
                                                : 'White spaces not allowed.',
                                    })}
                                    errors={errors}
                                />
                            </label>
                        </div>
                        <div className="mb-3">
                            <label className="block">
                                <OInputField
                                    wrapperClassName="relative z-0 w-full group"
                                    name="advertiser_id"
                                    inputLabel={
                                        <>
                                            {t('ADVERTISER_ID')}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </>
                                    }
                                    type="text"
                                    disabled={propertyId ? true : false}
                                    register={register('advertiser_id', {
                                        required: {
                                            value: true,
                                            message:
                                                'Please enter advertiser id.',
                                        },
                                        minLength: {
                                            value: 2,
                                            message:
                                                'Minimum length must be 2.',
                                        },
                                        validate: (value) =>
                                            value.trim()
                                                ? true
                                                : 'White spaces not allowed.',
                                    })}
                                    errors={errors}
                                />
                            </label>
                        </div>
                    </div>

                    <hr className="my-5" />

                   {!propertyId && <div className="text-center">
                        <button
                            type="submit"
                            className="bg-lime-500 hover:bg-[#8FC150] cursor-pointer   text-white  font-normal active:bg-slate-100 text-md px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150"
                        >
                            {t('SAVE_&_CONTINUE')}
                        </button>
                    </div>}
                </form>
            </div>
        </>
    );
};

export default InitialValidation;
